module.exports = __webpack_public_path__ + "img/wangjing_1.1c70a8dc.jpg";